/**
 * Die Schlafecke als Merkmal — und die Weiche, die sie erkennt.
 *
 * **Warum es das braucht.** Die Blätter und Dialoge laufen auf Radix, und zwar **modal**
 * (`modal = true` ist dort die Voreinstellung). Ein modaler Radix-Dialog setzt
 * `document.body.style.pointerEvents = 'none'` und gibt nur seinem eigenen Teilbaum
 * `pointer-events: auto` zurück. Der Schlafknopf steht ausserhalb dieses Teilbaums — ohne
 * Gegenmassnahme ist er sichtbar, aber **tot** (gefunden am 2026-09-13: in der Auswahl-Phase,
 * wo `SetupSheet` immer offen ist, liess sich der Knopf nicht drücken).
 *
 * Die Gegenmassnahme hat zwei Hälften:
 *
 * 1. `pointer-events: auto` auf der Ecke und der Scheibe (`Schlafscheibe.module.css`) — damit
 *    kommen Berührungen wieder an.
 * 2. Diese Weiche — denn nun deutet Radix denselben Tipper als „nach draussen geklickt" und
 *    schlösse das Blatt. Der Schlafknopf ist aber kein Weg nach draussen.
 */

/** Das Merkmal, das die Ecke trägt. */
export const SCHLAFECKE = 'data-schlafecke';

/** Liegt das getroffene Element in der Schlafecke? */
export function istAusSchlafecke(ziel: EventTarget | null): boolean {
  // Radix reicht das Ziel des ursprünglichen Ereignisses durch. Bei einem Fokuswechsel kann
  // es fehlen, und `document` ist kein `Element` — beides ist kein Fehler, nur kein Treffer.
  if (!ziel || !(ziel instanceof Element)) return false;
  return ziel.closest('[' + SCHLAFECKE + ']') !== null;
}

/**
 * Ob der **schwebende** Schlafknopf gezeigt wird.
 *
 * Hier und nicht im Bauteil, damit sich die Frage ohne Bildschirm prüfen lässt — dieselbe
 * Linie wie `inaktivitaet.ts::sollPausieren`.
 *
 * - `imFuss`: es gibt eine Fusszeile, die ihn trägt (im Bogen). Dann schwebt er nicht.
 * - `vollbildEditor`: ein Blatt füllt den Bildschirm und trägt unten eine **eigene**
 *   Steuerung. ⚠️ Der schwebende Knopf steht mit `z-index: 61` über jedem Blatt und verdeckte
 *   im Video-Annotationseditor erst die Texteingabe, dann das rechte Ende der Zeitleiste — und
 *   dort liegt das Videoende (Befund des Nutzers, 2026-09-20).
 * - `schlaeft`: ⚠️ **dann immer.** Die Scheibe liegt über allem; ohne Knopf käme der Prüfer
 *   nicht mehr heraus.
 */
export function zeigtSchwebendenKnopf(zustand: {
  imFuss: boolean;
  vollbildEditor: boolean;
  schlaeft: boolean;
}): boolean {
  if (zustand.schlaeft) return true;
  return !zustand.imFuss && !zustand.vollbildEditor;
}
